import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { eventSet }  from '../../store/eventSlice';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useApiGet from '../../hooks/useApiGet';
import PresetLink from './PresetLink';
import PresetDates from './PresetDates';
import PresetCountries from './PresetCountries';
import PresetCategories from './PresetCategories';
import Form from '../common/Form';

const Preset = () => {
    const { id } = useParams();
	const { t, i18n } = useTranslation();
	const lang = i18n.language;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [ cats, setCats ] = useState([]);
	const [ dates, setDates ] = useState([]);
	const [ cntrs, setCntrs ] = useState([]);
	const [ data, error, isLoading ] = useApiGet({ method: `/events/${id}` });

	useEffect(() => {
		if(data) {
			dispatch(eventSet(data.event));
		}
	},[data, dispatch]);

	return (
		<div>
	    	<h1>{data ? data.event.name[lang] : t('eventview.preset')}</h1>
            {error && <p className='error'>{t(error)}</p>}
			{isLoading && <p>{t('loader.title')}</p>}

			{data && <PresetLink event={data.event} cats={cats.join()} dates={dates.join()} cntrs={cntrs.join()}/>}
			{data && <PresetDates event={data.event} dates={dates} setDates={setDates}/>}
			{data && <PresetCountries event={data.event} cntrs={cntrs} setCntrs={setCntrs}/>}
			{data && <PresetCategories event={data.event} cats={cats} setCats={setCats}/>}

			<Form
				submit={t('eventform.back')}
				onSubmit={() => navigate(`/cabinet/eventview/${id}`)}
			>&nbsp;</Form>
		</div>
	);
};

export default Preset;
